<template>
  <div class="ecg">
    <!-- 显示该条心电数据的采集时间 -->
    <p> {{$t('tag.xindian.time')}}{{time}}</p>
    <!-- ECharts 图表容器， id 用于绑定图表实例 -->
    <div class="draw_echarts">
      <div class="chart" :id="id"></div>
    </div>
    <p class="chartTip">*{{$t('tag.shipin')}}</p>
    <!-- 参数面板：心率(bpm)、血氧(%) -->
    <div class="parameter">
      <ul>
        <li class="item">
          <span class="value">
            <template v-if="heart!==''">
            <strong>{{heart}}</strong>
            <i>bpm</i>
            </template>
            <template v-else>
              --
            </template>
          </span>
          <p class="title">{{$t('tag.xindian.xinlv')}}</p>
        </li>
  <li class="item">
          <span class="value">
            <template v-if="rhythm!==''">
              <strong>{{rhythm}}</strong>
              <!-- <i>%</i> -->
              <!-- <i class="iconfont">&#xe693;</i> -->
            </template>
            <template v-else>
              --
            </template>
          </span>
          <p class="title">{{$t('tag.xindian.jielv')}}</p>
        </li>

        <!-- <li class="item">
          <span class="value">
            <template v-if="ox!==''">
              <strong>{{ox}}</strong>
              <i>%</i>
              <i class="iconfont">&#xe693;</i>
            </template>
            <template v-else>
              --
            </template>
          </span>
          <p class="title">{{$t('tag.xindian.xueyang')}}</p>
        </li> -->
        <!-- <li class="item">
          <span class="value">
            <template v-if="af!==''">
              <strong>{{af}}</strong>
            </template>
            <template v-else>
              --
            </template>
          </span>
          <p class="title">{{$t('tag.xindian.fangchan')}}</p>
        </li> -->
      </ul>
    </div>
    <!-- 错误提示弹窗，显示数据格式错误 -->
    <modal-tip title="错误提示" :visible.sync="wranTip">
      <template slot="content">
        <ul class="modal-list">
          <li>
            <span class="p">数据格式错误</span>
          </li>
        </ul>
      </template>
    </modal-tip>
  </div>
</template>

<script>
export default {
  name: 'item',
  data () {
    return {
      ecgList: [],
      wranTip: false,
      xdata: []
    }
  },
  props: {
    // 心电数据数组
    ecgdata: {
      type: Array,
      default: () => []
    },
    // 心率
    heart: {
      type: String,
      default: ''
    },
    // 血氧
    ox: {
      type: String,
      default: ''
    },
    // 方波
    af: {
      type: String,
      default: ''
    },
    // 图表实例 ID
    id: {
      type: Number,
      default: 0
    },
    // 采集时间
    time: {
      type: String,
      default: ''
    },
    rhythm: {
      type: String,
      default: ''
    }
  },
  // 计算属性：生成 X 轴数据
  computed: {
    // 图表配置项
    options () {
      return {
        series: {
          type: 'line',// 折线图
          symbol: 'none',// 不显示数据点标记
          // sampling: 'average',
          // 蓝色线条
          itemStyle: {
            normal: {
              color: '#3696ea',
              lineStyle: {
                width: 1
              }
            }
          },
          data: this.ecgdata  // 绑定心电数据
        },
        color: '#3696ea',
        grid: {
          containLabel: true,
          top: 10,
          bottom: 10,
          left: 10,
          right: 10
        },
        // X 轴配置
        xAxis: {
          type: 'category',
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          data: this.xdata
        },
        // Y 轴配置
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            }
          }

        ],
        // 初始显示 30%-45% 区域，禁止缩放只允许左右滑动
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 30,
          // zoomLock: true,           // 锁定缩放，禁止缩放操作
          // zoomOnMouseWheel: false,  // 禁用鼠标滚轮缩放
          // moveOnMouseMove: true,    // 允许鼠标拖拽移动
          // moveOnMouseWheel: false   // 禁止鼠标滚轮移动
        }]
      }
    }
  },
  created () {
    // this.getEcg()
    // console.log(this.ecgdata)
  },
  mounted () {
    //组件挂载后执行 xS() 和 drawEcg()
    // this.conversionEcgData()
    this.$nextTick(function () {
      this.xS()//生成 X 轴数据（0,1,2,...n-1）
      this.drawEcg()//初始化并渲染 ECG 图表
    })
  },
  updated () {
    // this.drawEcg()
  },
  methods: {
    // 心电十六进制转10进制
    // conversionEcgData () {
    //   let len = this.ecgdata.length
    //   // let sub = 0
    //   let sen = ''
    //   let firstArr = []
    //   if (len % 3 !== 0) {
    //     this.wranTip = true
    //   } else {
    //     for (let i = 0; i < len; i += 3) {
    //       let s = this.ecgdata.substr(i, 3)
    //       let last = s.substr(1, 2)
    //       let fir = s.substr(0, 1)
    //       let v = parseInt(last, 16)
    //       if (fir === '0') {
    //         sen = -v / 1000
    //       } else if (fir === '1') {
    //         sen = v / 1000
    //       }
    //       firstArr.push(sen)
    //       this.xdata.push(i)
    //     }
    //   }
    // this.ecgList = firstArr
    // console.log('1000：' + this.ecgList)
    // },
    xS () {
      for (let i = 0; i < this.ecgdata.length; i++) {
        this.xdata.push(i)
      }
    },
    drawEcg () {
      this.init()
      this.setOption(this.options)
    },
    init () {
      // 创建 ECharts 实例，绑定 resize 事件，实现图表自适应
      let _this = this
      this.chart = this.$echarts.init(document.getElementById(this.id), 'light')
      window.addEventListener('resize', function () {
        _this.chart && _this.chart.resize()
      })
    },
    // 设置图表配置项
    setOption (option) {
      if (!this.chart) {
        return
      }
      this.chart.setOption(option)
    },
    // 销毁图表实例
    dispose () {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    }

  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/variable.styl';
@import '~styles/global.styl'
.ecg
  padding-bottom .5rem
  p
    font-size .26rem
    margin-top .3rem
  .chartTip
    font-size 0.28rem
    color #ccc
    text-align right
    margin 0 .1rem .1rem
  .draw_echarts
    margin .2rem 0 .1rem
    background url('~images/bg_ecg.png')
    background-size 6.04rem 6.22rem
    display flex
    height 2.6rem
    .chart
      width 100%
      height 100%

  .parameter
    display flex
    flex-flow column
    ul
      padding .3rem 0
      // background-color #ebf0f6
      display flex
      flex-flow row nowrap
      justify-content space-around
      justify-content space-around
      align-items center
      li
        display flex
        flex-flow column nowrap
        align-items center
        .value
          &.red
            color $redText
          &.orange
            color $orangeText
          // &.normal
          //   color $blueText

          .iconfont
            font-size .4rem
            color #1afa29
          strong
            font-size 0.4rem
            font-weight bold
          i
            margin 0.14rem 0 0 0.02rem
            font-size 0.24rem
        .title
          font-size 0.26rem
          color #707070
          margin-top .3rem
</style>



// WEBPACK FOOTER //
// src/pages/ecg/item.vue